import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'OnboardingStep';
const ENDPOINT = `/onboarding-steps/`;

@Injectable({
    providedIn: 'root'
})
export class OnboardingStepService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
